export default {
  headerDetails: "Product Details",
  "headerSign In": "Sign In",
  headerSettings: "Settings",
  headertransaction: "Orders",
  signin: "Sign In",
  signinReq: "* Indicates a field is required",
  emailReq:"Email*",
  passwordReq:"Password*",
  newTo: "New to CalmPurr?",
  createAccount: "Create Account",
  firstName: "First Name*",
  lastName: "Last Name*",
  streetaddress: "Street Address*",
  state: "State*",
  city: "City*",
  zip: "Zip/Postal Code*",
  phone: "Phone*",
  country: "Country*",
  done: "Done",
  categoryPopular: "Popular",
  categoryCustom: "Photo Custom",
  categoryFat: "Fat Cat",
  categorySlim: "Slim Cat",
  categoryMini: "Mini Cat",
  freeShippingTips: "Worldwide Free Shipping on All Orders!",
  alreadyHaveAccount: "Already have an account?",
  code: "Code",
  bestseller: "Best Sellers",
  recommendforyou: "Recommended for You",
  ourcustomershow: "Our Customer Show",
  faq: "FAQ",
  faq1: "Do you ship overseas?",
  faq1answer: "We ship to over 90 countries and regions worldwide. To check if delivery is available to your area, please try entering your address during the checkout process. We’re constantly working to expand our global shipping services✈️",
  faq2: "How long will it take to get my order?",
  faq2answer: "Depending on your region, standard shipping orders may take only 6–10 working days to arrive. Customized products require an additional 3–7 days of production time before shipping. You’ll receive a tracking email when your order is shipped.💖",
  faq3:"How to track my order?",
  faq3answer: "Once your order has been shipped, you can find the tracking number and all tracking information on your Order Details page to see the real-time status of your shipment.",
  faq4:"What is it made of? Is it safe?",
  faq4answer: "Our CalmPurr squishies are made with food-grade silicone — soft, safe, non-toxic, and gentle to the touch.",
  faq5:"How many times can it be squeezed? Is it easy to break?",
  faq5answer: "Our squishies are very durable and can be squeezed many times! We recommend keeping them in their original packaging when playing to maintain shape and quality longer.",
  review1: "I love him so much, and the packaging and presentation were very thoughtful as well. Looking forward to displaying this squishy guy somewhere special!",
  review2: "Super sweet squishy, amazing quality! It comes with a cute pouch with its accessories 😍",
  review3: "Demorou a chegar mas valeu completamente a pena. É uma réplica perfeita dum gatinho de Bengala, amoroso, bem pintado, lindo! 😍",
  review4: "I wasn\'t expecting so much fur, but honestly I don\'t even care because IT\'S SO CUTEEEEEEE. It\'s like a perfect little stress toy for me!",
  review5: "Super cute, super quality. Didn’t expect it to be such high quality with great accessories.",
  review6: "I lost my kitty in January and ordered this in her image... it has legitimately been healing for me.",
  review7: "I got this as a gift for my amazing friend 💓 the squishy came in perfect condition and it was 100% worth it!",
  review8: "I love my cat! Shipping was fast and I love the basket it came with! I want to get another one soon. Thank you Bambi!",
  aboutus:"About Us",
  contactus: "Contact Us",
  privacypolicy: "Privacy Policy",
  terms: "Terms & Conditions",
  returnpolicy: "Return Policy",
  footertitle: "Handmade Silicone Cats",
  home: "Home",
  shoppingcart: "Shopping Cart",
  orderhistory: "Order History",
  settings: "Settings",
  youshippinginfo: "Your Shipment Info",
  shipping: "Shipping",
  payment: "Payment",
  apply: "Apply",
  description: "Description",
  shippingInfo: "Shipping Information",
  buyText: "Buy",
  addtocart: "Items Added to Cart!",
  thankyou: "Thank you",
  yoursavings: "Your Savings",
  shippingInfoDetail: "Free Shipping.  Ships to Worldwide",
  cartisempty: "Your cart is empty",
  continueshopping: "Continue Shopping",
  itemtotal: "Item Total",
  freeshipping: "Free Shipping",
  ordertotal: "Order Total",
  orderhistory: "Order History",
  notorderyet: "You haven't made any orders.",
  shopnow: "Shop Now",
  changeemail: "Change Email Address",
  changepass: "Change Password",
  logout: "Logout",
  changeemailtips: "Use this form to change your email address.",
  currentemail: "Current e-mail address",
  newemail: "New e-mail address",
  confirmemail: "Confirm e-mail address",
  enteremail: "Enter e-mail address",
  enterconfirmemail: "Confirm new e-mail address",
  couponoff5title: "5% OFF",
  couponoff5desc: "Orders €50+",
  couponoff10title: "10% OFF",
  couponoff10desc: "Orders €60+",
  couponoff15title: "15% OFF",
  couponoff15desc: "Orders €80+",
  contactemail: "Please enter your email*",
  contactsubject: "Subject*",
  contactDesc: "Description*",
  areyousure: "Are you sure?",
  cancelshipping: "Do you want to cancel entering your shipping info?",
  enterpromotioncode: "Enter Promo Code",
  removeItemTips: "Remove this item from cart?",
  removeItem: "Remove Item",
  cancel: "Cancel",
  placeorder: "Place Order",
  currencyChangeTips: "Reference only. Transactions are settled in Euro (€).",
  selectCurrency: "Select Currency",
  approx: "Approx.",
  specialOffer: "Special Offer",
  christmasOffer: "New Year Special 2026",
  christmasOfferCopy: "Click the code below to copy it",
  christmasOfferCondition: "Order amount over €50",
};



// WEBPACK FOOTER //
// ./src/lang/en.js